import { sharedSchema } from "@shared-database/pgSchema";
import { User } from "@shared-database/models/user";
import {
  FileStatusEnumValues,
  AppEnumValues,
  FileOriginEnumValues,
} from "@shared-database/enums";
import {
  leoEnum,
  leoNotNullForeignID,
  leoID,
  timestampColumns,
} from "@shared-database/utils";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";
import { bigint, index, text } from "drizzle-orm/pg-core";
import { z } from "zod";

export const appEnum = leoEnum("App", AppEnumValues);
export const fileStatusEnum = leoEnum("FileStatus", FileStatusEnumValues);
export const fileOriginEnum = leoEnum("FileOrigin", FileOriginEnumValues);

export const File = sharedSchema.table(
  "File",
  {
    // Mixins
    ...timestampColumns,

    // Properties
    id: leoID("id"),
    name: text("name").notNull(),
    mimeType: text("mimeType").notNull(),
    size: bigint("size", { mode: "number" }).notNull(),
    status: fileStatusEnum("status").notNull(),
    origin: fileOriginEnum("origin"),
    errorText: text("errorText"),

    // References
    ownerId: leoNotNullForeignID("ownerId").references(() => User.id, {
      onDelete: "no action",
    }),
  },
  (table) => [
    index("File_createdAtIdx").on(table.createdAt),
    index("File_statusIdx").on(table.status),
    index("File_ownerIdx").on(table.ownerId),
  ],
);

// Types & Schemas
const FileOriginSchema = z.enum(FileOriginEnumValues);
export const FileInsertSchema = createInsertSchema(File, {
  origin: FileOriginSchema.nullable().optional(),
});
export const FileSelectSchema = createSelectSchema(File, {
  origin: FileOriginSchema.nullable(),
});
export type FileType = InferSelectModel<typeof File>;
export type SimpleFileType = Pick<FileType, "id" | "name">;
export type FileInsertType = InferInsertModel<typeof File>;
